import { NumberInput, NumberInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel } from '@mui/material';

export const GrayNumberInputWithUpperLabel = (props: NumberInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();

  return (
    <Box display="flex" flexDirection="column">
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <NumberInput
        {...props}
        className={props.className ? `${props.className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        InputProps={{
          ...props.InputProps,
          notched: false,
        }}
        sx={{
          mt: 0,
          mb: 0,
          ...props.sx,
          '& .MuiOutlinedInput-root': {
            boxSizing: 'border-box',
            minHeight: props.size === 'small' ? 40 : 56,
            height: props.size === 'small' ? 40 : 56,
            alignItems: 'center',
          },
        }}
      />
    </Box>
  );

};
